const WORD_GROUPS = {
  LONG_A_DIGRAPHS: [
    'brain',
    'chain',
    'day',
    'eight',
    'eighth',
    'grape',
    'lake',
    'neigh',
    'pain',
    'paint',
    'play',
    'rain',
    'say',
    'sleigh',
    'snake',
    'tape',
    'weigh',
  ],
  LONG_E_DIGRAPHS: [
    'beach',
    'brief',
    'clean',
    'eve',
    'field',
    'green',
    'he',
    'leak',
    'me',
    'peach',
    'pete',
    'piece',
    'screen',
    'she',
    'sleep',
    'squeal',
    'teeth',
    'theme',
    'these',
    'thief',
  ],
  LONG_I_DIGRAPHS: [
    'bike',
    'blind',
    'bride',
    'bright',
    'bye',
    'child',
    'cry',
    'die',
    'dry',
    'dye',
    'fight',
    'hi',
    'high',
    'kind',
    'lie',
    'lie',
    'light',
    'night',
    'pie',
    'prize',
    'right',
    'shine',
    'side',
    'sky',
    'tie',
    'write',
  ],
  LONG_O_DIGRAPHS: [
    'boat',
    'bone',
    'bowl',
    'cold',
    'doe',
    'ghost',
    'glow',
    'goes',
    'hoe',
    'hold',
    'home',
    'joke',
    'low',
    'no',
    'nose',
    'road',
    'robe',
    'rose',
    'slow',
    'snow',
    'soap',
    'throat',
    'toe',
  ],
  LONG_U_DIGRAPHS: [
    'blue',
    'brew',
    'bruise',
    'chew',
    'drew',
    'dune',
    'flute',
    'food',
    'fruit',
    'glue',
    'group',
    'juice',
    'new',
    'rude',
    'soon',
    'soup',
    'spoon',
    'suit',
    'tooth',
    'true',
    'tube',
    'wound',
    'zoo',
  ],
  R_CONTROLLED_IR: ['bird', 'dirt', 'skirt', 'twirl'],
  R_CONTROLLED_ER: ['fern', 'germ', 'herb', 'serve'],
  R_CONTROLLED_UR: ['burn', 'church', 'hurt', 'nurse'],
  R_CONTROLLED_AR: ['bark', 'barn', 'shark', 'star'],
  R_CONTROLLED_OR: ['horn', 'porch', 'short', 'storm', 'thorn'],
  DIPHTHONG_OI_OY: ['boil', 'boy', 'coin', 'joy', 'moist', 'soil', 'soy', 'toy'],
  DIPHTHONG_AU_AW: ['claw', 'dawn', 'draw', 'fault', 'haul', 'jaw', 'pause', 'sauce'],
  DIPHTHONG_OU_OW: ['clown', 'couch', 'frown', 'house', 'mouse', 'mouth', 'owl', 'town'],
};

export const LETTER_COMBINATION_GROUP_SUBTITLES = {
  LONG_A_DIGRAPHS: 'Long A',
  LONG_E_DIGRAPHS: 'Long E',
  LONG_I_DIGRAPHS: 'Long I',
  LONG_O_DIGRAPHS: 'Long O',
  LONG_U_DIGRAPHS: 'Long U',
  R_CONTROLLED_IR: 'IR',
  R_CONTROLLED_ER: 'ER',
  R_CONTROLLED_UR: 'UR',
  R_CONTROLLED_AR: 'AR',
  R_CONTROLLED_OR: 'OR',
  DIPHTHONG_OI_OY: 'OI-OY',
  DIPHTHONG_AU_AW: 'AU-AW',
  DIPHTHONG_OU_OW: 'OU-OW',
};

const words = {};

Object.keys(WORD_GROUPS).forEach((wordGroup) => {
  WORD_GROUPS[wordGroup].forEach((word) => {
    const id = `${wordGroup}_${word}`;

    words[id] = {
      id,
      word,
      title: word,
      subtitle: LETTER_COMBINATION_GROUP_SUBTITLES[wordGroup],
      type: 'WORD',
      pattern: wordGroup,
    };
  });
});

export default words;
